module.exports = __webpack_public_path__ + "img/Premium Icon active.077e51c1.svg";